/** @jsxRuntime classic */
/** @jsx jsx */
import React, { useContext } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { jsx } from "@emotion/core";
import { AuthContext } from '../../AuthProvider'
import { isShutdownAdmin } from '../action/shutdown'
import { AIChatGredientIcon, TasksMenuIcon, TodayMenuIcon, SettingGredientIcon, AdminGredientIcon, SiteLogoIcon, UpgradeIcon, AIChatGredientIcon2 } from '../LandingHeader/Feedback/icons/Icons'

const SideNav = ({children, theme, label = ''}) => {
  return (
    <span  className={`menu-block ${(theme == "dark") ? "sideBarDarkMode" : ""}`}>
      <span className='accent-text-color'>{label}</span>{children}
    </span>
  )
}

const HoverEffect = ({label = '', textRight = '-59px'}) => {
  return (
    <div className='menu-hover-pull-effect'>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="300" viewBox="0 0 20 300" fill="none" className='dark:stroke-black dark:fill-black'>
        <path d="M0 0C0 109.5 20 110.25 20 150C20 189.75 0 188.25 0 300L0 188.25V150V114.75L0 0Z" fill="white"/>
      </svg>
      <span className='menu-hover-pull-effect-text' style={{right: textRight}}>{label}</span>
    </div>
  )
}

function MainNavV2() {
  const [disableMenu, setDisableMenu] = useState(false)
  const theme = useSelector(state => state.theme.theme)
  const { subscription, userProfile } = useContext(AuthContext);
  // //console.log('userProfile', userProfile)
  const activeMenuCss = {
    '.active': {
        'svg': {
          'path': {
            '&.var-fill': {
              fill: 'var(--accent-color)'
            },
            '&.var-stroke': {
              stroke: 'var(--accent-color)'
            }
          },
          'radialGradient': {
            'stop':{
              '&.var-stop-color': {
                stopColor: 'var(--accent-color)'
              }
            }
          }
      }
    }
  }

  useEffect(() => {
    subscription?.isSubscriptionExpired && setDisableMenu(true)
  }, [subscription])

  return (
    disableMenu
    ?
    null
    :
    <>
      <div className="site-logo">
        <SiteLogoIcon color={`var(--accent-color)`} />
      </div>
      <ul className="ul-setting">
        <li className="li-setting" css={activeMenuCss}>
          <NavLink to={process.env.REACT_APP_ROOT || '/index.html'} end className={({ isActive }) => isActive ? 'li-links active' : 'li-links'}>
            <SideNav theme={theme} label="Today" >
              <TodayMenuIcon width="22" height="22" />
            </SideNav>
          </NavLink>
          <HoverEffect label="Today" />
        </li>
        <li className="li-setting" css={activeMenuCss}>
          <NavLink to="/tasks" className={({ isActive }) => isActive ? 'li-links active' : 'li-links'}>
            <SideNav theme={theme} label="Tasks">
              <TasksMenuIcon width="22" height="22" />
            </SideNav>
          </NavLink>
          <HoverEffect label="Tasks" textRight='-54px' />
        </li>
        {/* <li className="li-setting" css={activeMenuCss}>
          <NavLink to="/goals" className={({ isActive }) => isActive ? 'li-links active' : 'li-links'}>
            <SideNav theme={theme} label="Goals">
              <TasksMenuIcon width="22" height="22" />
            </SideNav>
          </NavLink>
          <HoverEffect label="Goals" textRight='-54px' />
        </li> */}
        <li className="li-setting" css={activeMenuCss}>
          <NavLink to='/ai-assistant' className={({ isActive }) => isActive ? 'li-links active' : 'li-links'}>
            <SideNav theme={theme} label="AI Assistant">
              <AIChatGredientIcon2 width="22" height="22" color={`var(--theme-mode-color-white-reverse)`} />
            </SideNav>
          </NavLink>
          <HoverEffect label="AI Assistant" textRight='-97px' />
        </li>
        <li className="li-setting" css={activeMenuCss}>
          <NavLink to='/settings' className={({ isActive }) => isActive ? 'li-links active' : 'li-links'}>
            <SideNav theme={theme} label="Settings">
              <SettingGredientIcon width="22" height="22" />
            </SideNav>
          </NavLink>
          <HoverEffect label="Settings" textRight='-72px' />
        </li>
        {
          isShutdownAdmin(userProfile?.email) &&
          <li className="li-setting" css={activeMenuCss}>
            <NavLink to='/admin/settings' className={({ isActive }) => isActive ? 'li-links active' : 'li-links'}>
              <SideNav theme={theme} label="Admin Settings">
                <AdminGredientIcon width="22" height="22" />
              </SideNav>
            </NavLink>
            <HoverEffect label="Admin Settings" textRight='-122px' />
          </li>
        }
        {
          subscription?.isFreeTrial &&
          <li className="li-setting" css={activeMenuCss}>
            <NavLink to='/subscription-plan' className={({ isActive }) => isActive ? 'li-links active' : 'li-links'}>
              <SideNav theme={theme} label="Subscription Plan">
                <UpgradeIcon width="22" height="22" id='upgrade-icon-sidbar' />
              </SideNav>
            </NavLink>
            <HoverEffect label="Subscription Plan" textRight='-133px' />
          </li>
        }
      </ul>
    </>
  )
}

export default MainNavV2